import { Box } from '@mui/material';
import Header from '../Header/Header';
import LoginFooter from './LoginFooter';
import { Outlet } from 'react-router-dom';


export default function LoginLayout() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100vw',
        pt: 0,
        mt: 0,
      })}
    >
      <Header />
      <Box
        sx={{
          backgroundColor: 'primary.main',
          width: '100%',
          height: { md: '97px', sm: '77px', xs: '67px' },
        }}
      />
      <Box component="main" sx={{ backgroundColor: 'primary.main', flexGrow: 1, height: '100%' }}>
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: 1,
            width: '100%',
            height: '100%',
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <LoginFooter />
    </Box>
  );
}
